/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateLocationDto } from '../models/CreateLocationDto';
import type { LocationDetailResponse } from '../models/LocationDetailResponse';
import type { LocationPhotoResponse } from '../models/LocationPhotoResponse';
import type { LocationWithScoreResponse } from '../models/LocationWithScoreResponse';
import type { MessageResponse } from '../models/MessageResponse';
import type { UpdateLocationDto } from '../models/UpdateLocationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LocationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Add a location
     * Create a new location for the authenticated client. The location is linked to the client profile automatically.
     * @returns LocationDetailResponse Location created successfully.
     * @throws ApiError
     */
    public locationsControllerCreate({
        requestBody,
    }: {
        requestBody: CreateLocationDto,
    }): CancelablePromise<LocationDetailResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/users/me/locations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Client profile not found.`,
            },
        });
    }
    /**
     * List own locations
     * Returns a paginated list of the authenticated client locations with optional filters.
     * @returns any List of locations.
     * @throws ApiError
     */
    public locationsControllerFindAllByUser({
        page = 1,
        limit = 20,
        sortBy,
        sortOrder = 'desc',
        disabled,
        selected,
        search,
    }: {
        /**
         * Page number
         */
        page?: number,
        /**
         * Items per page (max 200)
         */
        limit?: number,
        /**
         * Field to sort by
         */
        sortBy?: string,
        /**
         * Sort order (asc/desc)
         */
        sortOrder?: 'asc' | 'desc',
        /**
         * Filter by disabled status
         */
        disabled?: boolean,
        /**
         * Filter by selected status
         */
        selected?: boolean,
        /**
         * Search by label or address
         */
        search?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/me/locations',
            query: {
                'page': page,
                'limit': limit,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'disabled': disabled,
                'selected': selected,
                'search': search,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Client profile not found.`,
            },
        });
    }
    /**
     * List own locations with risk scores
     * Returns all active (non-disabled) locations for the authenticated client, each enriched with its computed neighborhood risk score.
     * @returns LocationWithScoreResponse List of locations with computed risk scores.
     * @throws ApiError
     */
    public locationsControllerFindAllWithScores(): CancelablePromise<Array<LocationWithScoreResponse>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/users/me/locations/with-scores',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Client profile not found.`,
            },
        });
    }
    /**
     * Get nearby locations
     * Returns the authenticated client locations within a radius of the given coordinates.
     * @returns any List of nearby locations with distance.
     * @throws ApiError
     */
    public locationsControllerFindNearby({
        latitude,
        longitude,
        radiusKm,
    }: {
        /**
         * Latitude of the search center
         */
        latitude: string,
        /**
         * Longitude of the search center
         */
        longitude: string,
        /**
         * Search radius in kilometers (default 10)
         */
        radiusKm?: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/locations/nearby',
            query: {
                'latitude': latitude,
                'longitude': longitude,
                'radiusKm': radiusKm,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
            },
        });
    }
    /**
     * Get location detail
     * Returns a location with its photos. Only the owning client can access it.
     * @returns LocationDetailResponse Location found.
     * @throws ApiError
     */
    public locationsControllerFindOne({
        id,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
    }): CancelablePromise<LocationDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/locations/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not the owner.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Update location
     * Update a location. Only the owning client can update it.
     * @returns LocationDetailResponse Location updated successfully.
     * @throws ApiError
     */
    public locationsControllerUpdate({
        id,
        requestBody,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
        requestBody: UpdateLocationDto,
    }): CancelablePromise<LocationDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/locations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `Unauthorized.`,
                403: `Forbidden. Not the owner.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Delete location
     * Delete a location and all associated data (photos, cascade). Only the owning client can delete.
     * @returns MessageResponse Location deleted successfully.
     * @throws ApiError
     */
    public locationsControllerRemove({
        id,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/locations/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not the owner.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Select a location
     * Set the given location as selected and deselect all other locations of the same client.
     * @returns LocationDetailResponse Location selected successfully.
     * @throws ApiError
     */
    public locationsControllerSelect({
        id,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
    }): CancelablePromise<LocationDetailResponse> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/locations/{id}/select',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Request societies for a location
     * Sends an email to WiSecure support requesting that societies be associated with the given location. Only the owning client can make this request.
     * @returns MessageResponse Society request sent successfully.
     * @throws ApiError
     */
    public locationsControllerRequestSocieties({
        id,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/locations/{id}/request-societies',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. CLIENT role required or not the owner.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Upload location photo
     * Upload a photo for a location. Only the owning client can upload photos.
     * @returns LocationPhotoResponse Photo uploaded successfully.
     * @throws ApiError
     */
    public locationsControllerAddPhoto({
        id,
        formData,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
        formData: {
            /**
             * Photo file (JPG, PNG, max 5MB)
             */
            file?: Blob;
        },
    }): CancelablePromise<LocationPhotoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/locations/{id}/photos',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not the owner.`,
                404: `Location not found.`,
            },
        });
    }
    /**
     * Remove location photo
     * Remove a photo from a location. Only the owning client can remove photos.
     * @returns MessageResponse Photo deleted successfully.
     * @throws ApiError
     */
    public locationsControllerRemovePhoto({
        id,
        photoId,
    }: {
        /**
         * Location unique identifier
         */
        id: string,
        /**
         * Photo unique identifier
         */
        photoId: string,
    }): CancelablePromise<MessageResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/locations/{id}/photos/{photoId}',
            path: {
                'id': id,
                'photoId': photoId,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden. Not the owner.`,
                404: `Location or photo not found.`,
            },
        });
    }
}
